var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "agentCard" },
    [
      _c(
        "el-row",
        { staticClass: "agentCardRow", attrs: { gutter: 40 } },
        [
          _c(
            "el-col",
            {
              staticClass: "agentCardRow-col",
              attrs: { xs: 24, sm: 24, lg: 12 }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "card-softstyle welcome-card enter-animation animationdelay-0s"
                },
                [
                  _c(
                    "el-col",
                    { staticClass: "icon-col", attrs: { span: 5 } },
                    [
                      _c("span", [
                        _c("i", { class: ["far", "fa-address-card"] })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "welcome-col", attrs: { span: 11 } },
                    [
                      _c("h1", { staticClass: "agentTitle" }, [
                        _vm._v(_vm._s(_vm.$t("dashboard.welcome")) + ", "),
                        _c("br"),
                        _c("span", [_vm._v(_vm._s(_vm.user.agentAccount))])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "info-col", attrs: { span: 8 } },
                    [
                      _c("div", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("dashboard.lastLoginTime")) +
                            " : "
                        ),
                        _c("br"),
                        _vm._v(
                          _vm._s(_vm.user.lastLoginTime) +
                            "\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("dashboard.lastLoginIp")) +
                            " : "
                        ),
                        _c("br"),
                        _vm._v(
                          _vm._s(_vm.user.lastLoginIp) +
                            "\n                    "
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("agent-card-info", {
            attrs: {
              loadingInfo: _vm.loadingUser,
              value: 0,
              label: _vm.$t("dashboard.agent.sendSMSTotal"),
              icon: "envelope",
              iconColor: "#b3404a",
              cardKey: 1
            }
          }),
          _vm._v(" "),
          _c("agent-card-info", {
            attrs: {
              loadingInfo: _vm.loadingProfile,
              value: _vm.profile.orgCount,
              label: _vm.$t("dashboard.agent.numOfOrgs"),
              icon: "building",
              iconColor: "#2d527c",
              cardKey: "2"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }